export const Help = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
<path d="M12 13C11.9801 11.6667 12.3151 9 16.0144 9C17.7963 9 18.4432 9.17052 19.1539 9.72842C20.1727 10.5282 20.5994 11.6331 20.4847 12.9252C20.4093 13.7758 19.809 14.9186 18.8684 15.4533C18.0526 15.9893 17.2417 16 16 16V19.4852" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="23.5" r="1" fill="currentColor" stroke="currentColor"/>
</svg>`;
